import { useCallback } from 'react'

import { ArrowRight, FileText } from '@gravity-ui/icons'
import { Button, Table, Tooltip } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import { formatPLN } from '@/utils/currency'
import { formatDate } from '@/utils/dates'

interface ReportRowProps {
  id: string;
  dateFrom: string;
  dateTo: string;
  amount: number;
  identifier: string;
  onNavigate: (id: string) => void;
}

export function ReportRow({
  id,
  dateFrom,
  dateTo,
  amount,
  identifier,
  onNavigate,
}: ReportRowProps) {
  const { t } = useTranslation()

  const handleNavigate = useCallback(() => {
    onNavigate(id)
  }, [id, onNavigate])

  return (
    <Table.Row key={id}>
      <Table.Cell>
        <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0 bg-rose-50 text-rose-600 dark:bg-rose-950/30 dark:text-rose-400">
          <FileText className="size-4" />
        </div>
      </Table.Cell>
      <Table.Cell>
        <span className="font-medium">
          {formatDate(dateFrom)} – {formatDate(dateTo)}
        </span>
      </Table.Cell>
      <Table.Cell>
        <div className="flex items-center gap-2">
          <span className="font-bold text-zinc-800 dark:text-zinc-200">
            {t('settlements.type_report')}
          </span>
          <span className="text-xs font-mono text-zinc-400 dark:text-zinc-500 bg-zinc-100 dark:bg-zinc-800 px-1.5 py-0.5 rounded">
            {identifier}
          </span>
        </div>
      </Table.Cell>
      <Table.Cell className="text-right font-black tabular-nums">
        <span className="text-rose-600 dark:text-rose-400">
          - {formatPLN(amount)} PLN
        </span>
      </Table.Cell>
      <Table.Cell>
        <div className="flex justify-end">
          <Tooltip delay={0}>
            <Button
              isIconOnly
              size="sm"
              variant="ghost"
              onClick={handleNavigate}
              aria-label={t('common.view')}
            >
              <ArrowRight className="size-4 text-zinc-400" />
            </Button>
            <Tooltip.Content>
              <p>{t('common.open_report')}</p>
            </Tooltip.Content>
          </Tooltip>
        </div>
      </Table.Cell>
    </Table.Row>
  )
}
